export const SET_TAB_INDEX = 'SET_TAB_INDEX';

export const SET_SORT_TYPE = 'SET_SORT_TYPE';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';

export const SET_USER = 'SET_USER';


export const SET_NEW_MESSAGE_DIALOG = 'SET_NEW_MESSAGE_DIALOG';
export const SET_MEMBER_DIALOG = 'SET_MEMBER_DIALOG';
export const SET_FILE_MANAGER_DIALOG = 'SET_FILE_MANAGER_DIALOG'
export const GET_USER = 'GET_USER';

export const GET_MESSAGES = 'GET_MESSAGES';
export const SELECT_ALL_MESSAGES = 'SELECT_ALL_MESSAGES';
export const UNSELECT_ALL_MESSAGES = 'UNSELECT_ALL_MESSAGES';

export const SET_OPTIONS = 'SET_OPTIONS';

export const SET_LABELS = 'SET_LABELS';

// FILE MANAGER TYPES

export const ATTACH_FILES = 'ATTACH_FILES';
export const CLEAR_FILES_TOBUFFER = 'CLEAR_FILES_TOBUFFER';
export const COPY_FILES_TOBUFFER = 'COPY_FILES_TOBUFFER';
export const CUT_FILES_TOBUFFER = 'CUT_FILES_TOBUFFER';
export const GET_FILES_LIST = 'GET_FILES_LIST';
export const GET_FOLDERS_LIST = 'GET_FOLDERS_LIST'
export const INVERSE_SELECTED_FILES = 'INVERSE_SELECTED_FILES';
export const PASTE_FILES = 'PASTE_FILES';
export const RUN_SORTING_FILTER = 'RUN_SORTING_FILTER';
export const SELECT_ALL_FILES = 'SELECT_ALL_FILES';
export const SET_HISTORY_INDEX = 'SET_HISTORY_INDEX';
export const SET_IMAGE_SETTINGS = 'SET_IMAGE_SETTINGS';
export const SET_ITEM_VIEW = 'SET_ITEM_VIEW';
export const SET_SELECTED_FILES = 'SET_SELECTED_FILES';
export const SET_SELECTED_FOLDER = 'SET_SELECTED_FOLDER';
export const SET_SORT_ORDER_BY = 'SET_SORT_ORDER_BY';
export const UNSET_ATTACH_FILES = 'UNSET_ATTACH_FILES';
export const UNSET_SELECTED_FILES = 'UNSET_SELECTED_FILES';
export const ARCHIVE_FILES = 'ARCHIVE_FILES';
export const CREATE_FILE = 'CREATE_FILE';
export const CREATE_FOLDER = 'CREATE_FOLDER';
export const DELETE_ITEMS = 'DELETE_ITEMS';
export const DUPLICATE_ITEM = 'DUPLICATE_ITEM';
export const EMPTY_DIR = 'EMPTY_DIR';
export const RENAME_FILE = 'RENAME_FILE';
export const SAVE_IMAGE = 'SAVE_IMAGE';
export const UNZIP_FILE = 'UNZIP_FILE';
export const UPLOAD_FILES = 'UPLOAD_FILES';